<section
  data-header-class="white"
  class="single-page section"
>
  <noda-button
    iconId="arrow-right"
    iconName="controls/arrow-right"
    text="articles.back-to-articles"
    type="round-gradient"
    class="single-page__nav"
    [icon]="true"
    [link]="'/articles' | addLangPrefix | async"
    [reverse]="true"
  />
  <noda-article-hero [article]="articlesService.article()" />
  <noda-banner-cta [bannerInfo]="bannerHeroCTA" />
  <article class="single-page__article">
    @for (item of processedContent; track $index) {
      @switch (item.contentType) {
        @case ('banner') {
          <noda-banner-cta [bannerInfo]="item.bannerInfo" />
        }
        @default {
          <div [innerHTML]="item.contentPart | sanitize: 'html'"></div>
        }
      }
    }
    @if (hasFAQ) {
      <div class="single-page__faq-header">
        <h2 class="heading-1-v2">FAQs</h2>
      </div>
      <noda-faq-section
        class="articles"
        [faqsConfig]="articlesService.article().faq"
      />
    }
  </article>
  <noda-button
    iconId="arrow-right"
    iconName="controls/arrow-right"
    type="gradient"
    class="single-page__btn"
    [icon]="true"
    [link]="faqButton.routerLink"
    [text]="faqButton.text"
  />
</section>
